import script from "./layer-detail.vue?vue&type=script&setup=true&lang=ts"
export * from "./layer-detail.vue?vue&type=script&setup=true&lang=ts"

import "./layer-detail.vue?vue&type=style&index=0&id=8d0e2edc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d0e2edc"]])

export default __exports__